<svg
    viewbox="0 0 34 30"
    stroke="currentColor"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
    d="M0.800049 5.8H32.8"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
    <path
    d="M29.8 28.8H3.80005C2.10005 28.8 0.800049 27.5 0.800049
    25.8V3.8C0.800049 2.1 2.10005 0.800003 3.80005 0.800003H29.8C31.5
    0.800003 32.8 2.1 32.8 3.8V25.8C32.8 27.4 31.4 28.8 29.8 28.8Z"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
    <path
    d="M14.8 20.8H5.80005V24.8H14.8V20.8Z"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
    <path
    d="M27.8 9.8H5.80005V16.8H27.8V9.8Z"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
    <path
    d="M17.8 20.8H27.8"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
    <path
    d="M17.8 24.8H27.8"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>